import { BreadcrumbChild } from './styled';

type Props = {
  children?: string;
};

const BreadcrumbDivider = ({ children = '/' }: Props) => (
  <BreadcrumbChild>{children}</BreadcrumbChild>
);

export default BreadcrumbDivider;
